export enum FileUploadErrorType {
  NETWORK = 'Network',
  NO_ACCESS = 'NoAccess',
  INVALID_SIZE = 'InvalidSize',
  INVALID_TYPE = 'InvalidType',
  INVALID_FILE = 'InvalidFile',
}
